import React from 'react';

// Hosts that are the real production site. Anywhere else (testdev, hom,
// localhost, preview URLs) is treated as a non-production sandbox and shows
// the banner. Runtime check by hostname => no build flag needed, and it can
// never show up on production.
const PROD_HOSTS = ['yapps.app', 'www.yapps.app'];

function SandboxBanner() {
  if (typeof window === 'undefined') return null;
  if (PROD_HOSTS.includes(window.location.hostname)) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: '#6d28d9',
        color: '#fff',
        textAlign: 'center',
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.04em',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.15)',
        pointerEvents: 'none',
      }}
    >
      🧪 SANDBOX — test environment ({window.location.hostname}) · not
      production
    </div>
  );
}

export default SandboxBanner;
